<template>
  <header class="sitenav">
    <div class="" v-if="mostrarMenu">
      <div class="">
        <div class="w-100">
          <b-navbar toggleable="lg" type="light">
            <b-navbar-brand to="/" v-if="mostrarLogo">
              <img
                v-if="home === false"
                class="img-fluid"
                src="../assets/imgs/verano23/logo-verano-cinepolis.png"
                alt="Verano con sabor a cinepolis"
              />
            </b-navbar-brand>
            <b-navbar-brand to="/" v-else>
              <img
                v-if="home === false"
                class="img-fluid d-lg-none"
                src="../assets/imgs/verano23/logo-verano-cinepolis.png"
                alt="Verano con sabor a cinepolis"
              />
              <div class="py-5">&nbsp;</div>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <template>
                  <!-- <b-nav-item class=" btnrojo text-center pt-2 pt-lg-4 bold" href="/">Registrar ticket</b-nav-item>
                  
                  <b-nav-item
                    class=" btnrojo text-center pt-2 pt-lg-4 bold"
                    to="/mis-participaciones"
                  >Mis participaciones</b-nav-item>

                  <b-nav-item class=" btnrojo text-center pt-2 pt-lg-4 bold" href="/ganadores">Ganadores</b-nav-item> -->

                  <!-- <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/ganadores"
                  >
                    Ganadores
                  </b-nav-item> -->
                </template>

                <template
                  v-if="
                    userProfile != undefined && userProfile.email != undefined
                  "
                >
                  <b-nav-item
                    
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/mecanica"
                  >
                    Mecánica
                  </b-nav-item>

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/dashboard"
                  >
                    Registrar ticket
                  </b-nav-item>

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/mis-participaciones"
                  >
                    Mis puntos
                  </b-nav-item>

                  <!-- <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/premios"
                  >
                    Premios
                  </b-nav-item> -->

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/ganadores"
                  >
                    Ganadores
                  </b-nav-item>

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold"
                    @click="logout()"
                  >
                    Cerrar sesión
                  </b-nav-item>
                </template>

                <template v-else>
                  <b-nav-item
                    v-if="mostrarInicio === true"
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/"
                  >
                    Inicio
                  </b-nav-item>

                  <b-nav-item
                    
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/mecanica"
                  >
                    Mecánica
                  </b-nav-item>

                  <b-nav-item
                    v-if="mostrarInicio === false"
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    href="./#inicia-sesion"
                  >
                    Login
                  </b-nav-item>

                  <!-- <b-nav-item
                    v-if="mostrarInicio === false"
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    href="./#registro"
                  >
                    Registro
                  </b-nav-item> -->

                  <!-- <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/premios"
                  >
                    Premios
                  </b-nav-item> -->

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/ganadores"
                  >
                    Ganadores
                  </b-nav-item>

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    href="#"
                    target="_blank"
                  >
                    Términos y Condiciones
                  </b-nav-item>
                </template>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import * as fb from "../firebase";
import { mapState } from "vuex";
export default {
  data() {
    return {
      uid: null,
      mostrarLogo: true,
      mostrarMenu: true,
      mostrarInicio: false,
      home: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      if (
        this.$route.name == "Dashboard" ||
        this.$route.name == "Resultado" ||
        this.$route.name == "Login" || this.$route.name == "Mecanica"
      ) {
        this.mostrarLogo = false;
      } else {
        this.mostrarLogo = true;
      }

      if (this.$route.name == "Login" ) {
        this.home = true;
      } else {
        this.home = false;
      }

      if (
        this.$route.name == "Premios" ||
        this.$route.name == "Ganadores" ||
        this.$route.name == "Mecanica"
      ) {
        this.mostrarInicio = true;
      } else {
        this.mostrarInicio = false;
      }

      if (this.$route.name == "Dinamica") {
        this.mostrarMenu = false;
      } else {
        this.mostrarMenu = true;
      }
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    if (
      this.$route.name == "Dashboard" ||
      this.$route.name == "Resultado" ||
      this.$route.name == "Login" || this.$route.name == "Mecanica"
    ) {
      this.mostrarLogo = false;
    }

    if (this.$route.name == "Login") {
      this.home = true;
    } else {
      this.home = false;
    }

    if (
      this.$route.name == "Premios" ||
      this.$route.name == "Ganadores" ||
      this.$route.name == "Mecanica"
    ) {
      this.mostrarInicio = true;
    } else {
      this.mostrarInicio = false;
    }

    if (this.$route.name == "Dinamica") {
      this.mostrarMenu = false;
    }

    try {
      this.uid = fb.auth.currentUser.uid;
    } catch (e) {
      //
    }

    try {
      //console.log({useremail: this.userProfile.email})
    } catch (e) {
      //
    }

    //console.log({user: this.userProfile})
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>
